import React, { useEffect, useState, useCallback, useContext } from "react";
import classNames from "lib/classNames";
import GuideContainer from "./GuideContainer";
import GuideLink from "./GuideLink";
import GuideVideo from "./GuideVideo";
import YtClothing from "svgs/yt-clothing.jpeg";
import YtDesigning from "svgs/yt-designing.jpeg";
import YtDropshipping from "svgs/yt-dropshipping.jpeg";
import YtFreeGift from "svgs/yt-free-gift.jpeg";
import YtFreeShipping from "svgs/yt-free-shipping.jpeg";
import YtShippingProtection from "svgs/yt-shipping-protection.jpeg";
import styles from "styles/tutorial.module.scss";

const TutorialModal = ({ isOpen, setIsOpen }) => {
  return (
    isOpen && (
      <div>
        <div className={styles.overlay} onClick={() => setIsOpen(false)}></div>
        <div className={styles.container}>
          <h4
            className={classNames(
              "flex-1 text-gray-600 text-md font-bold mb-4"
            )}
          >
            Here are some quick setup tools. If you need further help please
            contact the support team.
          </h4>
          <div className={styles.close} onClick={() => setIsOpen(false)}>
            X
          </div>
          <div className={classNames("flex items-stretch")}>
            <GuideContainer
              title="Frequent Asked Questions"
              className="flex-1"
              link="https://monsterapps.crisp.help/en/"
              linkLabel="Visit Helpdesk"
              styles={{ marginRight: "10px", maxWidth: "35%" }}
            >
              <GuideLink
                label="Why isn’t my MonsterUpsell cart appearing?"
                link="https://monsterapps.crisp.help/en/article/activate-deactivate-monster-cart-19okfn1/"
              />
              <GuideLink
                label="Can you run multiple Campaigns at the same time?"
                link="https://monsterapps.crisp.help/en/article/multiple-campaigns-at-the-same-time-rules-and-targeting-1tt85ak/"
              />
              <GuideLink
                label="Why isn't the store mini cart in corner syncing to MonsterUpsells?"
                link="https://monsterapps.crisp.help/en/article/cart-button-in-corner-trouble-shooting-1paigp8"
              />
              <GuideLink
                label="Is it possible to create Buy X Get Y offers?"
                link="https://monsterapps.crisp.help/en/article/shopify-auto-discounts-setup-buy-x-get-y-and-more-jlyqfr/"
              />
              <GuideLink
                label="Does MonsterUpsells work with Shopify Marketplace?"
                link="https://monsterapps.crisp.help/en/article/shopify-markets-multi-currency-setup-1ab07h1"
              />
              <GuideLink
                label="How do i turn off my default theme cart?"
                link="https://monsterapps.crisp.help/en/article/my-old-cart-drawerajax-cart-is-showing-jpwk52"
              />
            </GuideContainer>
            <GuideContainer
              title="Setup Guides and Best Practices"
              className="flex-1"
              link="https://monsterapps.crisp.help/en/"
              linkLabel="More Setup Guides"
              itemsClassName="flex items-start flex-wrap"
              itemsStyles={{ justifyContent: "space-between" }}
            >
              <GuideVideo
                label="🎁 Add To Unlock Free Gifts"
                link="https://www.youtube.com/watch?v=7x68Cw-C3C4"
                image={YtFreeGift}
              />
              <GuideVideo
                label="🚚 Add To Unlock Free Shipping"
                link="https://www.youtube.com/watch?v=Tn6CKnyprA4"
                image={YtFreeShipping}
              />
              <GuideVideo
                label="🛡 One tick Upsells"
                link="https://www.youtube.com/watch?v=dNva0Jrd3FQ"
                image={YtShippingProtection}
              />
              <GuideVideo
                label={"Dropshiping / Gadgets  (Best Practices)"}
                link="https://www.youtube.com/watch?v=psPl2PNYt40"
                image={YtDropshipping}
              />
              <GuideVideo
                label="Clothing / Accessories / Brand (Best Practices)"
                link="https://www.youtube.com/watch?v=utNw-leSD9o"
                image={YtClothing}
              />
              <GuideVideo
                label="Setup & Design Cart"
                link="https://www.youtube.com/watch?v=OOHWtIoAf-w"
                image={YtDesigning}
              />
            </GuideContainer>
          </div>
        </div>
      </div>
    )
  );
};

export default TutorialModal;
